import React, {useState}from 'react'
import {BsTwitter, BsInstagram} from 'react-icons/bs'
import {FaFacebookF, FaWhatsapp, FaLinkedinIn} from 'react-icons/fa'
import {images} from '../../constants'
import {AppWrap, MotionWrap} from '../../wrapper'
import CallToAction from '../../components/CallToAction/CallToAction'
import './Footer.scss'

const Footer = () => {
  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    phone: '', 
    service: '', 
    message: '' 
  })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const {name, email, phone, service, message} = formData;
 
  const handleChangeInput = (e) => {
    const {name, value} = e.target;
    setFormData({...formData, [name]: value});
  }

  const handleSubmit = () =>{
    setLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      setLoading(false);
      setIsFormSubmitted(true);
    }, 2000);
  }

  const services = [
    'Education & Training',
    'Business Expansion & Market Entry', 
    'Marketing & Brand Development',
    'Technology & Software Development'
  ]

  return (
    <div className='app__footer-wrapper'>
      {/* Call to Action Section */}

      <CallToAction 
        title="Ready to elevate your skills, brand, or digital presence?"
        description="Speak with our team today and discover how we can help transform your business."
        primaryButton="Contact Us"
        secondaryButton="Hire Scoolj Lab"
        primaryAction={() => document.getElementById('contact-form').scrollIntoView()}
        secondaryAction={() => window.open('#', '_blank')}
      />

      <h2 className='head-text'>Get In Touch</h2>
      <p className='p-text app__footer-subtitle'>
        We'd love to hear from you. Whether you're looking for training, business support, 
        branding, or digital product development, our team is ready to help.
      </p>

      <div className='app__footer-cards'>
        <div className='app__footer-card'>
          <img src={images.email} alt='email' />
          <h4 className='bold-text'>Email Us</h4>
          <a href="mailto:info@scooljinstitute.com" className='p-text'>info@scooljinstitute.com</a>
          <a href="mailto:support@scooljinstitute.com" className='p-text'>support@scooljinstitute.com</a>
        </div>
        
        <div className='app__footer-card'>
          <img src={images.mobile} alt='mobile' />
          <h4 className='bold-text'>Call Us</h4>
          <a href="tel:+2347034756746" className='p-text'>+234 703 475 6746</a>
          <a href="tel:+2349121026059" className='p-text'>+234 912 102 6059</a>
        </div>
        
        <div className='app__footer-card'>
          <img src={images.map} alt='Address' />
          <h4 className='bold-text'>Visit Us</h4>
          <p className='p-text'>Suite 18A Education Complex, <br/> Ransome Kuti Road, Unilag, Lagos, Nigeria</p>
          {/* <p className='p-text app__footer-hours'>
            <span className='bold-text'>Business Hours:</span><br/>
            Mon-Fri: 9:00 AM - 5:00 PM<br/>
            Sat: 10:00 AM - 2:00 PM
          </p> */}
        </div>
      </div>

      {!isFormSubmitted ? (
        <div id="contact-form" className='app__footer-form app__flex'>
          <div className='app__footer-form-row'>
            <div className='app__footer-form-group'>
              <label className='p-text'>Name *</label>
              <input 
                className="p-text" 
                type="text"  
                value={name} 
                name="name" 
                onChange={handleChangeInput}
                required
              />
            </div>
            
            <div className='app__footer-form-group'>
              <label className='p-text'>Email *</label>
              <input 
                className='p-text' 
                type='email'  
                value={email} 
                name="email" 
                onChange={handleChangeInput}
                required
              />
            </div>
          </div>

          <div className='app__footer-form-row'>
            <div className='app__footer-form-group'>
              <label className='p-text'>Phone Number</label>
              <input 
                className='p-text' 
                type='tel'  
                value={phone} 
                name="phone" 
                onChange={handleChangeInput}
              />
            </div>
            
            <div className='app__footer-form-group'>
              <label className='p-text'>Service Interested In</label>
              <select 
                className='p-text' 
                value={service} 
                name="service" 
                onChange={handleChangeInput}
              >
                <option value="">Select a service</option>
                {services.map((serviceOption, index) => (
                  <option key={index} value={serviceOption}>{serviceOption}</option>
                ))}
              </select>
            </div>
          </div>

          <div className='app__footer-form-group app__footer-form-group--full'>
            <label className='p-text'>Message *</label>
            <textarea 
              className="p-text"  
              value={message} 
              name="message" 
              onChange={handleChangeInput}
              rows="5"
              placeholder="Tell us about your project or requirements..."
              required
            />
          </div>
          
          <button 
            type='button' 
            className='app__footer-submit-btn' 
            onClick={handleSubmit}
            disabled={loading || !name || !email || !message}
          >
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </div>
      ) : (
        <div className='app__footer-success'>
          <h3 className='head-text'>Thank you for getting in touch!</h3>
          <p className='p-text'>We'll respond to your message within 24 hours.</p>
        </div>
      )}

      {/* Footer Links & Social Media */}
      <div className='app__footer-bottom'>
        <div className='app__footer-links'>
          <div className='app__footer-links-section'>
            <h4 className='bold-text'>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#featured-projects">Portfolio</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className='app__footer-links-section'>
            <h4 className='bold-text'>Services</h4>
            <ul>
              {services.map((service, index) => (
                <li key={index}><a href="#services">{service}</a></li>
              ))}
            </ul>
          </div>
          
          <div className='app__footer-links-section'>
            <h4 className='bold-text'>Follow Us</h4>
            <div className='app__footer-social'>
              <a href="https://twitter.com/scooljinstitute" target="_blank" rel="noopener noreferrer">
                <BsTwitter />
              </a>
              <a href="https://web.facebook.com/scooljinstitute/" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/scooljinstitute" target="_blank" rel="noopener noreferrer">
                <BsInstagram />
              </a>
              <a href="https://www.linkedin.com/company/scooljinstitute" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
              <a href="https://wa.me/2347034756746" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>
        
        <div className='app__footer-copyright'>
          <p className='p-text'>© 2025 Scoolj Institute. All rights reserved.</p>
        </div>
      </div>
    </ div>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg'
)

// import React, {useState}from 'react'
// import {BsTwitter, BsInstagram} from 'react-icons/bs'
// import {FaFacebookF, FaWhatsapp} from 'react-icons/fa'


// import {images} from '../../constants'

// import {AppWrap, MotionWrap} from '../../wrapper'
// import {client} from '../../client'
// import './Footer.scss'



// import './Footer.scss'
// const Footer = () => {

//   const [formData, setFormData] = useState({ name: ' ', email: ' ', message: ' '})
//   const [isFormSubmitted, setIsFormSubmitted] = useState(false)
//   const [loading, setLoading] = useState(false)


// const {name, email, message} = formData;
 
// const handleChangeInput = (e) => {
//   const {name, value} = e.target;

//   setFormData({...formData, [name]: value});

// }

// const handleSubmit = () =>{
//   setLoading(true);

//   const contact ={
//     _type: 'contact',
//     name: name,
//     email: email,
//     message: message,
//   }


//   // client.create(contact)

//   //     .then(() =>{
//   //       setLoading(false)
//   //       setIsFormSubmitted(true)
//   //     })
// }

//   return (

//     <>
//       <h2 className='head-text'>
//         Send a message to us
//       </h2>

//       <div className='app__footer-cards'>
//         <div className='app__footer-card'>
//           <img src={images.email} alt='email' />
//           <a href="mailto:info@scooljinstitute.com" className='p-text'>info@scooljinstitute.com</a>
//           <a href="mailto:apply@scooljinstitute.com" className='p-text'>apply@scooljinstitute.com</a>
//         </div>
//          <div className='app__footer-card'>
//           <img src={images.mobile} alt='mobile' />
//           <a href="tel: +234 7034 756 746" className='p-text'>+234 7034-756-746</a>
//           <a href="tel: +234 9121 026 059" className='p-text'>+234 9121-026-059</a>
//         </div>
//         <div className='app__footer-card'>
//           <img src={images.map} alt='Address' />
//           <a href="map" className='p-text'>Office 18a Ransome Kuti Shopping complex, Faculty of Education, University of Lagos. </a>
//         </div>
//       </div>

//     {!isFormSubmitted ?
  
//         <div className='app__footer-form app__flex'>

//         <div className='app__flex'>
//         <p className='p-text'>Name:</p>
//           <input className="p-text" type="text"  value={name} name="name" onChange={handleChangeInput}/>
           
//         </div>

//         <div className='app__flex'>
//         <p className='p-text'>Email:</p>
//           <input className='p-text' type='email'  value={email} name="email" onChange={handleChangeInput} />
//         </div>

//         <div >
//           <p className='p-text'>Message:</p>
//           <textarea className="p-text"  value={message} name="message" onChange={handleChangeInput}/>
//         </div>

          
//           <button type='button' className='p-text' onClick={handleSubmit}>{loading ? 'sending' : 'Send Message' } </button>
//       </div>

//       :
//       <div >
//         <h3 className='head-text' >Thank you for getting in touch</h3>
//       </div>
//     }
//     <div className='app__social_footer'>
//         <div>
//         <a
//             href="https://twitter.com/scooljinstitute"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <BsTwitter />
//          </a>
//         </div>
//         <div>
//         <a
//             href="https://web.facebook.com/scooljinstitute/"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <FaFacebookF />
//           </a>
//         </div>
//         <div>
//         <a
//             href="https://wa.me/2347034756746"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <BsInstagram />
//           </a>
//         </div>
       
//          <div>
//          <a
//             href="https://wa.me/2347034756746"
            
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//               <FaWhatsapp  />
//             </a>
//         </div>
      
//     </div>
//     </>
//   )
// }

// export default AppWrap(
//   MotionWrap(Footer, 'app__footer'),
//   'contact',
//   'app__whitebg'
// )
